import script from "./PackingGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackingGuide.vue?vue&type=script&lang=ts&setup=true"

import "./PackingGuide.vue?vue&type=style&index=0&id=88eb8640&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88eb8640"]])

export default __exports__